import moment from "moment";
import { exists, capitalize } from "./funciones";
import { afiliatedServices, caseType, enumStatus } from "../helpers/options";

const isLocksmithGreenGroup = (data, service) =>
  [
    service?.code,
    service?.product?.code,
    data?.lastService?.product?.code,
  ].includes(afiliatedServices.LOCKSMITH);

export const smsText = {
  greenGroup: (data, provider, service, _case) => {
    return `*POR FAVOR RECUERDA QUE NO SE DEBE PEDIR LA UBICACIÓN AL CLIENTE*

*SERVICIO DE TU/GRUERO ${
      data?.thirdPartyParticularCustomerName ? " (NO SOLVENTAR AVERIA)" : ""
    }${data?.particularCustomer?._id ? " Particular" : ""}*
- *FECHA DE CREACIÓN*: ${moment(data?.createdAt).format("DD/MM/YYYY")} ${moment(
      data?.createdAt
    ).format("LT")}
- *FECHA DE SERVICIO*: ${moment(
      data?.scheduleDate ? data?.scheduleDate : data?.createdAt
    ).format("DD/MM/YYYY")} ${moment(
      data?.scheduleDate ? data?.scheduleDate : data?.createdAt
    ).format("LT")}     
- *CLIENTE*: ${
      capitalize(
        data?.thirdPartyParticularCustomerName ||
          data?.particularCustomer?.firstName ||
          data?.membership?.customer?.firstName ||
          data?.vehicleData?.firstName
      ) +
      " " +
      capitalize(
        data?.thirdPartyParticularCustomerLastName ||
          data?.particularCustomer?.lastName ||
          data?.membership?.customer?.lastName ||
          data?.vehicleData?.lastName
      )
    }
- *TELÉFONO*: ${
      [
        caseType.AFFILIATED,
        caseType.PARTICULAR,
        caseType.PRIMARY_CARE,
      ].includes(data?.caseType)
        ? exists(
            data?.thirdPartyServicePhonePrefix || data?.contactNumberPrefix
          ) + exists(data?.thirdPartyServicePhoneNumber || data?.contactNumber)
        : ""
    }${
      [caseType.ALLY].includes(data?.caseType)
        ? exists(data?.vehicleData.phonePrefix) +
          exists(data?.vehicleData.phoneNumber)
        : ""
    }
- *PLACA*: ${exists(
      data?.thirdPartyVehiclePlate ||
        data?.particularCustomer?.vehiclePlate ||
        data?.membership?.vehicle?.plate ||
        data?.vehicleData?.plate
    )}
- *VEHICULO*: ${
      capitalize(
        data?.thirdPartyVehicleBrand?.brand ||
          data?.particularCustomer?.vehicleBrand?.brand ||
          data?.membership?.vehicle?.brand ||
          data?.vehicleData?.brand?.brand
      ) +
      " " +
      capitalize(
        data?.thirdPartyVehicleModel?.model ||
          data?.particularCustomer?.vehicleModel?.model ||
          data?.membership?.vehicle?.model ||
          data?.vehicleData?.model?.model
      ) +
      " " +
      capitalize(
        data?.thirdPartyVehicleYear ||
          data?.particularCustomer?.vehicleYear ||
          data?.membership?.vehicle?.year ||
          data?.vehicleData?.year
      ) +
      " " +
      capitalize(
        data?.thirdPartyVehicleColor ||
          data?.particularCustomer?.vehicleColor ||
          data?.membership?.vehicle?.color ||
          data?.vehicleData?.color
      )
    }
- *AVERÍA*: ${capitalize(data?.fault?.description)}
- *COMENTARIO AVERÍA*: ${capitalize(
      data?.customerFailureDescription
        ? data?.customerFailureDescription
        : "Ninguno"
    )}
- *ORIGEN*: ${
      capitalize(data?.originAddress) +
      "\nReferencia: " +
      capitalize(data?.originReferencePoint) +
      "\nCiudad: " +
      capitalize(data?.originCity?.name) +
      "\nEstado: " +
      capitalize(data?.originState?.name)
    }\n- *OPERADOR*: ${
      capitalize(data?.user?.firstName) + " " + capitalize(data?.user?.lastName)
    }${
      data?.lastService?.code
        ? `\n- *CÓDIGO DE SERVICIO*: ${exists(data?.lastService?.code)}`
        : ""
    }
- *${isLocksmithGreenGroup(data, service) ? "PROVEEDOR RECOMENDADO" : "MOTORIZADO"}*: ${
      isLocksmithGreenGroup(data, service) && !provider?.contactName
        ? "Sin proveedor recomendado"
        : `@${capitalize(provider?.contactName)}`
    }\n- *SERVICIO SOLICITADO*: ${
      isLocksmithGreenGroup(data, service)
        ? "Cerrajería"
        : capitalize(service?.product || data?.lastService?.product?.name)
    } ${
      data?.thirdPartyParticularCustomerName
        ? " *(AV EXTENDIDO - SERVICIO A TERCERO)*"
        : ""
    }

*POR FAVOR RECUERDA QUE NO SE DEBE PEDIR LA UBICACIÓN AL CLIENTE*`;
  },

  messageToClient: (data, provider) => {
    if (data?.lastStage?.name !== enumStatus?.SCHEDULED) {
      return `Ya tienes un asistente vial asignado✅\nDatos del motorizado:
      \n\n*Nombre: ${capitalize(provider?.contactName)}* ${
        [provider?.phonePrefix, provider?.phoneNumber].filter(Boolean).join("-")
          ? `\n*Número de contacto: ${[
              provider?.phonePrefix,
              provider?.phoneNumber,
            ]
              .filter(Boolean)
              .join("-")}*`
          : ""
      }${"\n*Tiempo de espera estimado:  25 minutos*"}\n\nProcura mantenerte en el lugar indicado para que nuestro asistente pueda ubicarte 🏍️🚨\n\nPodrás hacer seguimiento a tu asistente vial asignado a través de este link:\n\n ${
        window.location.origin + `/following-link/${data?._id}`
      }`;
    } else {
      return `Ya tienes un asistente vial asignado✅\nDatos del motorizado:
      \n\n*Nombre: @${capitalize(provider?.contactName)}* ${
        [provider?.phonePrefix, provider?.phoneNumber].filter(Boolean).join("-")
          ? `\n*Número de contacto: ${[
              provider?.phonePrefix,
              provider?.phoneNumber,
            ]
              .filter(Boolean)
              .join("-")}*`
          : ""
      } ${`\n\n⏰SERVICIO AGENDADO PARA ${
        data?.scheduleDate && moment(data?.scheduleDate).format(`DD/MM/YYYY`)
      } a las ${
        data?.scheduleDate && moment(data?.scheduleDate).format(`LT`)
      }`}\n\nProcura mantenerte en el lugar indicado para que nuestro asistente pueda ubicarte 🏍️🚨`;
    }
  },

  messageLinkToClient: (data, provider) => {
    return `Ya tienes un gruero asignado✅\nDatos del gruero:
    \n\n*Nombre: @${capitalize(provider?.contactName)}* ${
      [provider?.phonePrefix, provider?.phoneNumber].filter(Boolean).join("-")
        ? `\n*Número de contacto: ${[
            provider?.phonePrefix,
            provider?.phoneNumber,
          ]
            .filter(Boolean)
            .join("-")}*`
        : ""
    } ${
      data?.lastStage?.name !== enumStatus?.TOW_ASSIGNED
        ? `\n*Tiempo de espera estimado: 45 minutos*`
        : ""
    }${
      data?.lastStage?.name === enumStatus?.TOW_ASSIGNED && data?.scheduleDate
        ? `⏰SERVICIO AGENDADO PARA ${
            data?.scheduleDate &&
            moment(data?.scheduleDate).format(`DD/MM/YYYY`)
          } a las ${
            data?.scheduleDate && moment(data?.scheduleDate).format(`LT`)
          }`
        : ""
    }\n\nProcura mantenerte en el lugar indicado para que nuestro gruero pueda ubicarte 🏍️🚨
    ${
      ((data?.scheduleDate &&
        ![enumStatus?.SEARCHING_TOW, enumStatus?.TOW_ASSIGNED].includes(
          data?.lastStage?.name
        )) ||
        (!data?.scheduleDate &&
          ![enumStatus?.SEARCHING_TOW].includes(data?.lastStage?.name))) &&
      provider?.isInternal !== false
        ? `\n\nPodrás hacer seguimiento a tu gruero asignado a través de este link:\n\n ${
            window.location.origin + `/following-link/${data?._id}`
          }`
        : ""
    }
    `;
  },

  locksmithMessageToClient: (data, provider) => {
    const isDCOrMiranda = ["DISTRITO CAPITAL", "MIRANDA"].includes(
      `${data?.originState?.name}`.toUpperCase()
    );

    if (isDCOrMiranda) {
      return `Hola, ya estamos en contacto con el proveedor que atenderá tu servicio de cerrajería 🔑

En breve te iremos informando el estatus de tu caso y te notificaremos cuando el proveedor vaya en camino.

Gracias por confiar en Tu Gruero ✅`;
    }

    const phone = [provider?.phonePrefix, provider?.phoneNumber]
      .filter(Boolean)
      .join("-");
    const providerBlock = provider?.contactName
      ? `\n\nDatos del proveedor:\n\n*Nombre: ${capitalize(
          provider?.contactName
        )} *${
          phone ? `\n*Teléfono: ${phone} *` : ""
        }\n\nComunícate directamente con el proveedor para coordinar la atención.`
      : "";

    return `Hola, te recomendamos el siguiente proveedor para tu servicio de cerrajería 🔑${providerBlock}

*Tu Gruero asume el costo del servicio hasta un máximo de 30 USD.* Si el costo es mayor, la diferencia corre por tu cuenta.

Paga el servicio al proveedor y envíanos la factura por este chat. *La factura es obligatoria para procesar tu reembolso.*

El reembolso se realiza en un máximo de *7 días hábiles* después de recibir la factura ✅`;
  },

  yellowGroup: (data, provider, service) => {
    return `*SERVICIO DE TU/GRUERO${
      data?.thirdPartyParticularCustomerName ? " (NO SOLVENTAR AVERIA)" : ""
    }${data?.particularCustomer?._id ? " Particular" : ""}*
- *FECHA DE CREACIÓN*: ${moment(data?.createdAt).format("DD/MM/YYYY")} ${moment(
      data?.createdAt
    ).format("LT")}
- *FECHA DE SERVICIO*: ${moment(
      data?.scheduleDate ? data?.scheduleDate : data?.createdAt
    ).format("DD/MM/YYYY")} ${moment(
      data?.scheduleDate ? data?.scheduleDate : data?.createdAt
    ).format("LT")}     
- *PLACA*: ${exists(
      data?.particularCustomer?.vehiclePlate ||
        data?.membership?.vehicle?.plate ||
        data?.vehicleData?.plate
    )}
- *TELÉFONO*:${
      [
        caseType.AFFILIATED,
        caseType.PARTICULAR,
        caseType.PRIMARY_CARE,
      ].includes(data?.caseType)
        ? exists(
            data?.thirdPartyServicePhonePrefix || data?.contactNumberPrefix
          ) + exists(data?.thirdPartyServicePhoneNumber || data?.contactNumber)
        : ""
    }${
      [caseType.ALLY].includes(data?.caseType)
        ? exists(data?.vehicleData.phonePrefix) +
          exists(data?.vehicleData.phoneNumber)
        : ""
    }
- *VEHICULO*: ${
      capitalize(
        data?.thirdPartyVehicleBrand?.brand ||
          data?.particularCustomer?.vehicleBrand?.brand ||
          data?.membership?.vehicle?.brand ||
          data?.vehicleData?.brand?.brand
      ) +
      " " +
      capitalize(
        data?.thirdPartyVehicleModel?.model ||
          data?.particularCustomer?.vehicleModel?.model ||
          data?.membership?.vehicle?.model ||
          data?.vehicleData?.model?.model
      ) +
      " " +
      capitalize(
        data?.thirdPartyVehicleYear ||
          data?.particularCustomer?.vehicleYear ||
          data?.membership?.vehicle?.year ||
          data?.vehicleData?.year
      ) +
      " " +
      capitalize(
        data?.thirdPartyVehicleColor ||
          data?.particularCustomer?.vehicleColor ||
          data?.membership?.vehicle?.color ||
          data?.vehicleData?.color
      )
    }
- *AVERÍA*: ${capitalize(data?.fault?.description)}
- *COMENTARIO AVERÍA*: ${capitalize(
      data?.customerFailureDescription
        ? data?.customerFailureDescription
        : "Ninguno"
    )}
- *ORIGEN*: ${
      capitalize(data?.originAddress) +
      "\nReferencia: " +
      capitalize(data?.originReferencePoint) +
      "\nCiudad: " +
      capitalize(data?.originCity?.name) +
      "\nEstado: " +
      capitalize(data?.originState?.name)
    }
${
  data?.destinyState?.name
    ? `- *DESTINO*: ${
        capitalize(data?.destinyAddress) +
        "\nReferencia: " +
        capitalize(data?.destinyReferencePoint) +
        "\nCiudad: " +
        capitalize(data?.destinyCity?.name) +
        "\nEstado: " +
        capitalize(data?.destinyState?.name)
      }`
    : ""
} \n- *PROVEEDOR*: ${capitalize(
      data?.lastService?.provider?.contactName
    )}\n- *COSTO DE PROVEEDOR*: ${exists(
      data?.lastService?.price
    )}$ \n- *OPERADOR*: ${
      capitalize(data?.user?.firstName) + " " + capitalize(data?.user?.lastName)
    }
${
  data?.membership?.beginDate
    ? `- *VIGENCIA*: ${exists(
        moment(data?.membership?.beginDate).format("DD/MM/YYYY")
      )}-${exists(moment(data?.membership?.endDate).format("DD/MM/YYYY"))}`
    : ""
}
${
  data?.membership?.vehicle?.city
    ? `- *DOMICILIO*: ${
        capitalize(data?.membership?.vehicle?.city) +
        ", " +
        capitalize(data?.membership?.vehicle?.state)
      }`
    : ""
}
${
  data?.membership?.towServices
    ? `- *CANTIDAD DE CASOS*: ${data?.membership?.towServices?.length}`
    : ""
}
${
  `- *OPERADOR*: ` +
  capitalize(data?.user?.firstName) +
  " " +
  capitalize(data?.user?.lastName)
}
${
  data?.lastService?.code
    ? `- *CÓDIGO DE SERVICIO*: ${exists(data?.lastService?.code)}`
    : ""
}
${
  data?.membership?.code
    ? `- *CÓDIGO DE PRODUCTO*:${
        " " +
        exists(data?.membership?.code?.prefixCode) +
        "-" +
        exists(data?.membership?.saleChannel?.shortName) +
        "-" +
        exists(data?.membership?.membershipId)
      }`
    : ""
}\n- *SERVICIO SOLICITADO*: ${capitalize(
      service?.product || data?.lastService?.product?.name
    )} ${
      data?.thirdPartyParticularCustomerName
        ? " *(AV EXTENDIDO - SERVICIO A TERCERO)*"
        : ""
    }`;
  },

  towBroadcastInternalMessage: (data) => {
    return `*SERVICIO DE TU/GRUERO*
- *FECHA DE CREACIÓN*: ${moment(data?.createdAt).format("DD/MM/YYYY")} ${moment(
      data?.createdAt
    ).format("LT")}
- *FECHA DE SERVICIO*: ${moment(
      data?.scheduleDate ? data?.scheduleDate : data?.createdAt
    ).format("DD/MM/YYYY")} ${moment(
      data?.scheduleDate ? data?.scheduleDate : data?.createdAt
    ).format("LT")}     
- *AVERÍA*: ${capitalize(data?.fault?.description)}
- *COMENTARIO AVERÍA*: ${capitalize(
      data?.customerFailureDescription
        ? data?.customerFailureDescription
        : "Ninguno"
    )}
- *VEHICULO*: ${
      capitalize(
        data?.thirdPartyVehicleBrand?.brand ||
          data?.particularCustomer?.vehicleBrand?.brand ||
          data?.membership?.vehicle?.brand ||
          data?.vehicleData?.brand?.brand
      ) +
      " " +
      capitalize(
        data?.thirdPartyVehicleModel?.model ||
          data?.particularCustomer?.vehicleModel?.model ||
          data?.membership?.vehicle?.model ||
          data?.vehicleData?.model?.model
      ) +
      " " +
      capitalize(
        data?.thirdPartyVehicleYear ||
          data?.particularCustomer?.vehicleYear ||
          data?.membership?.vehicle?.year ||
          data?.vehicleData?.year
      ) +
      " " +
      capitalize(
        data?.thirdPartyVehicleColor ||
          data?.particularCustomer?.vehicleColor ||
          data?.membership?.vehicle?.color ||
          data?.vehicleData?.color
      )
    }
- *ORIGEN*: ${
      capitalize(data?.originAddress) +
      "\nReferencia: " +
      capitalize(data?.originReferencePoint) +
      "\nCiudad: " +
      capitalize(data?.originCity?.name) +
      "\nEstado: " +
      capitalize(data?.originState?.name)
    }
\n\n*Interesados responder con el precio y el tiempo de espera*`;
  },
  towBroadcastExternalMessage: (data) => {
    return `*SERVICIO DE TU/GRUERO*
- *FECHA DE CREACIÓN*: ${moment(data?.createdAt).format("DD/MM/YYYY")} ${moment(
      data?.createdAt
    ).format("LT")}
- *FECHA DE SERVICIO*: ${moment(
      data?.scheduleDate ? data?.scheduleDate : data?.createdAt
    ).format("DD/MM/YYYY")} ${moment(
      data?.scheduleDate ? data?.scheduleDate : data?.createdAt
    ).format("LT")}     
- *AVERÍA*: ${capitalize(data?.fault?.description)}
- *COMENTARIO AVERÍA*: ${capitalize(
      data?.customerFailureDescription
        ? data?.customerFailureDescription
        : "Ninguno"
    )}
- *VEHICULO*: ${
      capitalize(
        data?.thirdPartyVehicleBrand?.brand ||
          data?.particularCustomer?.vehicleBrand?.brand ||
          data?.membership?.vehicle?.brand ||
          data?.vehicleData?.brand?.brand
      ) +
      " " +
      capitalize(
        data?.thirdPartyVehicleModel?.model ||
          data?.particularCustomer?.vehicleModel?.model ||
          data?.membership?.vehicle?.model ||
          data?.vehicleData?.model?.model
      ) +
      " " +
      capitalize(
        data?.thirdPartyVehicleYear ||
          data?.particularCustomer?.vehicleYear ||
          data?.membership?.vehicle?.year ||
          data?.vehicleData?.year
      ) +
      " " +
      capitalize(
        data?.thirdPartyVehicleColor ||
          data?.particularCustomer?.vehicleColor ||
          data?.membership?.vehicle?.color ||
          data?.vehicleData?.color
      )
    }
- *ORIGEN*: ${
      capitalize(data?.originAddress) +
      "\nReferencia: " +
      capitalize(data?.originReferencePoint) +
      "\nCiudad: " +
      capitalize(data?.originCity?.name) +
      "\nEstado: " +
      capitalize(data?.originState?.name)
    }
${
  data?.destinyState?.name
    ? `- *DESTINO*: ${
        capitalize(data?.destinyAddress) +
        "\nReferencia: " +
        capitalize(data?.destinyReferencePoint) +
        "\nCiudad: " +
        capitalize(data?.destinyCity?.name) +
        "\nEstado: " +
        capitalize(data?.destinyState?.name)
      }`
    : ""
}
${data?.caseKm ? `\n- *DISTANCIA*: ` : ""}${
      exists(data?.caseKm) + " Km"
    }\n\n*Interesados responder con el precio y el tiempo de espera*`;
  },

  towMesage: (data) => {
    return `*POR FAVOR RECUERDA QUE NO SE DEBE PEDIR LA UBICACIÓN AL CLIENTE*

*SERVICIO DE TU/GRUERO*
- *FECHA DE CREACIÓN*: ${moment(data?.createdAt).format("DD/MM/YYYY")} ${moment(
      data?.createdAt
    ).format("LT")}
- *FECHA DE SERVICIO*: ${moment(
      data?.scheduleDate ? data?.scheduleDate : data?.createdAt
    ).format("DD/MM/YYYY")} ${moment(
      data?.scheduleDate ? data?.scheduleDate : data?.createdAt
    ).format("LT")}     
- *CLIENTE*: ${
      exists(
        data?.particularCustomer?.firstName ||
          data?.membership?.customer?.firstName ||
          data?.vehicleData?.firstName
      ) +
      " " +
      exists(
        data?.particularCustomer?.lastName ||
          data?.membership?.customer?.lastName ||
          data?.vehicleData?.lastName
      )
    }
- *TELÉFONO*: ${
      [caseType.AFFILIATED, caseType.PARTICULAR].includes(data?.caseType)
        ? exists(
            data?.thirdPartyServicePhonePrefix || data?.contactNumberPrefix
          ) + exists(data?.thirdPartyServicePhoneNumber || data?.contactNumber)
        : ""
    }${
      [caseType.ALLY].includes(data?.caseType)
        ? exists(data?.vehicleData.phonePrefix) +
          exists(data?.vehicleData.phoneNumber)
        : ""
    }
- *PLACA*: ${exists(
      data?.particularCustomer?.vehiclePlate ||
        data?.membership?.vehicle?.plate ||
        data?.vehicleData?.plate
    )}
- *VEHICULO*: ${
      capitalize(
        data?.particularCustomer?.vehicleBrand?.brand ||
          data?.membership?.vehicle?.brand ||
          data?.vehicleData?.brand?.brand
      ) +
      " " +
      capitalize(
        data?.particularCustomer?.vehicleModel?.model ||
          data?.membership?.vehicle?.model ||
          data?.vehicleData?.model?.model
      ) +
      " " +
      capitalize(
        data?.particularCustomer?.vehicleYear ||
          data?.membership?.vehicle?.year ||
          data?.vehicleData?.year
      ) +
      " " +
      capitalize(
        data?.particularCustomer?.vehicleColor ||
          data?.membership?.vehicle?.color ||
          data?.vehicleData?.color
      )
    }
- *AVERÍA*: ${capitalize(data?.fault?.description)}
- *COMENTARIO AVERÍA*: ${capitalize(
      data?.customerFailureDescription
        ? data?.customerFailureDescription
        : "Ninguno"
    )}
- *ORIGEN*: ${
      capitalize(data?.originAddress) +
      "\nReferencia: " +
      capitalize(data?.originReferencePoint) +
      "\nCiudad: " +
      capitalize(data?.originCity?.name) +
      "\nEstado: " +
      capitalize(data?.originState?.name)
    }
    ${
      data?.destinyState?.name
        ? `- *DESTINO*: ${
            capitalize(data?.destinyAddress) +
            "\nReferencia: " +
            capitalize(data?.destinyReferencePoint) +
            "\nCiudad: " +
            capitalize(data?.destinyCity?.name) +
            "\nEstado: " +
            capitalize(data?.destinyState?.name)
          }`
        : ""
    }
${data?.caseKm ? `- *DISTANCIA*: ${exists(data?.caseKm)} Km` : ""}
- *OPERADOR*: ${
      capitalize(data?.user?.firstName) + " " + capitalize(data?.user?.lastName)
    }${
      data?.lastService?.code
        ? `\n- *CÓDIGO DE SERVICIO*: ${exists(data?.lastService?.code)}`
        : ""
    }${
      data?.lastService?.price
        ? `\n- *COSTO DE PROVEEDOR*: ${exists(data?.lastService?.price) + "$"}`
        : ""
    }\n\n- *Estimado Gruero por favor llamar al cliente e indicarle al mismo Marca, Modelo, Color de la grua que le asistirá.*
    \n\n- *SE SOLICITA POR FAVOR QUE AL TOMAR EL SERVICIO NOS ENVÍEN 3 FOTOS, AL SUBIRLO A LA GRÚA, SOBRE LA GRÚA Y AL BAJARLO DE LA GRÚA. RECUERDE QUE EL CÓDIGO DEL SERVICIO DEBE ESTAR REFLEJADO EN LA FACTURA.*

*POR FAVOR RECUERDA QUE NO SE DEBE PEDIR LA UBICACIÓN AL CLIENTE*
`;
  },

  towServiceMessage: (data) => {
    return `*SERVICIO DE TU/GRUERO${
      data?.particularCustomer?._id ? " Particular" : ""
    }*
- *FECHA DE CREACIÓN*: ${moment(data?.createdAt).format("DD/MM/YYYY")} ${moment(
      data?.createdAt
    ).format("LT")}
- *FECHA DE SERVICIO*: ${moment(
      data?.scheduleDate ? data?.scheduleDate : data?.createdAt
    ).format("DD/MM/YYYY")} ${moment(
      data?.scheduleDate ? data?.scheduleDate : data?.createdAt
    ).format("LT")}     
- *CLIENTE*: ${
      exists(
        data?.particularCustomer?.firstName ||
          data?.membership?.customer?.firstName ||
          data?.vehicleData?.firstName
      ) +
      " " +
      exists(
        data?.particularCustomer?.lastName ||
          data?.membership?.customer?.lastName ||
          data?.vehicleData?.lastName
      )
    }
- *TELÉFONO*: ${
      exists(data?.contactNumberPrefix) + "-" + exists(data?.contactNumber)
    }
- *PLACA*: ${exists(
      data?.particularCustomer?.vehiclePlate ||
        data?.membership?.vehicle?.plate ||
        data?.vehicleData?.plate
    )}
- *VEHICULO*: ${
      capitalize(
        data?.particularCustomer?.vehicleBrand?.brand ||
          data?.membership?.vehicle?.brand ||
          data?.vehicleData?.brand?.brand
      ) +
      " " +
      capitalize(
        data?.particularCustomer?.vehicleModel?.model ||
          data?.membership?.vehicle?.model ||
          data?.vehicleData?.model?.model
      ) +
      " " +
      capitalize(
        data?.particularCustomer?.vehicleYear ||
          data?.membership?.vehicle?.year ||
          data?.vehicleData?.year
      ) +
      " " +
      capitalize(
        data?.particularCustomer?.vehicleColor ||
          data?.membership?.vehicle?.color ||
          data?.vehicleData?.color
      )
    }
- *AVERÍA*: ${capitalize(data?.fault?.description)}
- *COMENTARIO AVERÍA*: ${capitalize(
      data?.customerFailureDescription
        ? data?.customerFailureDescription
        : "Ninguno"
    )}
- *ORIGEN*: ${
      capitalize(data?.originAddress) +
      "\nReferencia: " +
      capitalize(data?.originReferencePoint) +
      "\nCiudad: " +
      capitalize(data?.originCity?.name) +
      "\nEstado: " +
      capitalize(data?.originState?.name)
    }
    ${
      data?.destinyState?.name
        ? `- *DESTINO*: ${
            capitalize(data?.destinyAddress) +
            "\nReferencia: " +
            capitalize(data?.destinyReferencePoint) +
            "\nCiudad: " +
            capitalize(data?.destinyCity?.name) +
            "\nEstado: " +
            capitalize(data?.destinyState?.name)
          }`
        : ""
    }
    ${data?.caseKm ? `- *DISTANCIA*: ${exists(data?.caseKm)} Km ` : ""}
${
  data?.services?.length > 0 && data?.services[0]?.type === "Asistencia vial"
    ? `- *VERIFICADO POR*: ${data?.services[0]?.provider?.contactName} `
    : ""
}${
      data?.services?.length > 0 && data?.services[0]?.type === "Grua"
        ? `- *VERIFICADO POR*: Servicio de grúa directo`
        : ""
    }
${
  data?.lastService?.provider?.contactName
    ? `- *PROVEEDOR*: ${capitalize(data?.lastService?.provider?.contactName)}`
    : ""
}
${
  data?.lastService?.price
    ? `- *COSTO DE PROVEEDOR*: ${exists(data?.lastService?.price)}$`
    : ""
}${
      data?.membership?.customer?.homeCity
        ? `- *DOMICILIO*:  ${
            capitalize(data?.membership?.customer?.homeState) +
            capitalize(data?.membership?.customer?.homeCity) +
            capitalize(data?.membership?.customer?.homeMunicipality) +
            capitalize(data?.membership?.customer?.homeAddress)
          }`
        : ""
    }
${
  data?.membership?.beginDate
    ? `- *VIGENCIA*: ${exists(
        moment(data?.membership?.beginDate).format("DD/MM/YYYY")
      )}-${exists(moment(data?.membership?.endDate).format("DD/MM/YYYY"))}`
    : ""
}
${
  data?.membership?.vehicle?.city
    ? `- *DOMICILIO*: ${
        capitalize(data?.membership?.vehicle?.city) +
        ", " +
        capitalize(data?.membership?.vehicle?.state)
      }`
    : ""
}
${
  data?.membership?.towServices
    ? `- *CANTIDAD DE CASOS*: ${data?.membership?.towServices?.length}`
    : ""
}
${
  `- *OPERADOR*: ` +
  capitalize(data?.user?.firstName) +
  " " +
  capitalize(data?.user?.lastName)
}${
      data?.lastService?.code
        ? `\n- *CÓDIGO DE SERVICIO*: ${exists(data?.lastService?.code)}`
        : ""
    }${
      data?.membership?.code
        ? `\n- *CÓDIGO DE PRODUCTO*:${
            " " +
            exists(data?.membership?.code?.prefixCode) +
            "-" +
            exists(data?.membership?.saleChannel?.shortName) +
            "-" +
            exists(data?.membership?.membershipId)
          }`
        : ""
    }`;
  },

  taxiMessage: (data) => {
    return `*¡Tu tranquilidad es nuestra prioridad! 🚗✨*


Sabemos que los imprevistos en la vía son estresantes, especialmente si viajas acompañado. Para que todos lleguen a su destino con comodidad, te obsequiamos un código de descuento en *Ridery:*

🎫 Código: *${exists(data?.taxi)}* 💰 Beneficio: $2 de descuento en traslados de hasta $15.

*Válido para un solo uso. ¡Buen viaje!*`;
  },

  sendDailyReport: (data) => {
    return `*REPORTE DEL DÍA*

- *TURNO*: ${moment(data?.startDate).format("DD/MM/YYYY hh:mm a")} - ${moment(
      data?.endDate
    ).format("DD/MM/YYYY hh:mm a")}
- *NOMBRE*: ${data?.user}
- *NÚMERO DE QUEJAS*: ${data?.reportedErrors || 0}
- *NÚMERO DE PARTICULARES*: ${data?.doneCases?.particular || 0}
- *NÚMERO DE AGENDADOS*: ${data?.activeCases?.scheduled || 0}
- *SERVICIOS ACTIVOS*: ${data?.activeCases?.active || 0}
- *TOTAL SERVICIOS PRESTADOS*: ${data?.doneCases?.done || 0}
- *GRÚAS EXTERNAS APROBADAS*: ${data?.doneCases?.doneTowExternal || 0}
${
  [
    data?.doneCases?.towExternalCcs
      ? Object.entries(data?.doneCases?.towExternalCcs).map(
          ([key, value]) => `- Caracas: ${value} ${key}`
        )
      : null,
    data?.doneCases?.towExternal
      ? Object.entries(data?.doneCases?.towExternal).map(
          ([key, value]) =>
            `- ${value?.name ? capitalize(value.name) : ""}: ${""}: ${
              value.num
            }`
        )
      : null,
  ]
    .filter(Boolean) // Elimina los elementos nulos (vacíos)
    .flat() // Aplana el array si hay sub-arrays
    .join("\n") // Une todo con saltos de línea
}
- *GRÚAS INTERNAS APROBADAS*: ${data?.doneCases?.doneTowInternal || 0}
    `;
  },
};
